"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectGroup = exports.Select = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const Message_1 = __importDefault(require("../Notifications/Message/Message"));
function getSelectClassNames(props) {
    return classnames_1.default({
        'dropdown-native': !props.inputGroup,
        'show-country-native': props.inputGroup,
        [props.className]: !!props.className,
    });
}
const Select = (props) => {
    const { className, inputGroup, errorMessage, options } = props, rest = __rest(props, ["className", "inputGroup", "errorMessage", "options"]);
    const selectClasses = getSelectClassNames(props);
    return (React.createElement(React.Fragment, null,
        React.createElement("select", Object.assign({}, rest, { className: selectClasses }), options.map((option) => (React.createElement("option", { disabled: option.disabled, value: option.value, key: option.key ? option.key : option.value }, option.label)))),
        !inputGroup && errorMessage && (React.createElement(Message_1.default, { type: "error", message: errorMessage, form: true }))));
};
exports.Select = Select;
exports.Select.defaultProps = {
    inputGroup: false,
};
const SelectGroup = (props) => {
    const { className, inputGroup, errorMessage, optionsGroup } = props, rest = __rest(props, ["className", "inputGroup", "errorMessage", "optionsGroup"]);
    const selectClasses = getSelectClassNames(props);
    return (React.createElement(React.Fragment, null,
        React.createElement("select", Object.assign({}, rest, { className: selectClasses }), optionsGroup
            .filter((group) => group.options.length > 0)
            .map((group) => (React.createElement("optgroup", { label: group.label, key: group.label }, group.options.map((option) => (React.createElement("option", { disabled: option.disabled, value: option.value, label: option.label, key: option.key ? option.key : option.value }, option.label))))))),
        !inputGroup && errorMessage && (React.createElement(Message_1.default, { type: "error", message: errorMessage, form: true }))));
};
exports.SelectGroup = SelectGroup;
exports.SelectGroup.defaultProps = {
    inputGroup: false,
};
//# sourceMappingURL=Select.js.map